import {useLocation} from 'react-router'

/**
 * Extracts path segments from pathname, filtering out 'hierarchyId' and its value.
 * URL pattern: /:featureName/hierarchyId/:hierarchyId/* -> returns feature-relevant segments only.
 * Example: ['MyFeature', 'hierarchyId', 'abc-123', 'details'] -> ['MyFeature', 'details']
 */
export const getFeatureSegments = (segments: string[]): string[] => {
  const hierarchyIdIndex = segments.indexOf('hierarchyId')
  if (hierarchyIdIndex === -1) {
    return segments
  }
  // Remove 'hierarchyId' and its value (next segment), keep the rest
  return [...segments.slice(0, hierarchyIdIndex), ...segments.slice(hierarchyIdIndex + 2)]
}

/**
 * Returns path segments from current URL, optionally filtering out hierarchyId segments.
 * @param options.excludeHierarchyId - If true, excludes 'hierarchyId' and its value from segments
 */
export const usePathSegments = (options?: {excludeHierarchyId?: boolean}): string[] => {
  const {pathname} = useLocation()
  const segments = pathname.split('/').filter(Boolean)

  if (options?.excludeHierarchyId) {
    return getFeatureSegments(segments)
  }

  return segments
}
